import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_GET_TASK_QUEUE = (id?: number) => ['getTaskQueue', id].filter(Boolean)

export const getTaskQueue = async (id: number): Promise<IUnitTaskQueueModel> =>
  axios.get(`/management/UnitProgramTask/GetTaskQueue?id=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getTaskQueue

type Props = {
  config?: QueryConfig<QueryFnType>
  id: number
}

export const useManagementGetTaskQueue = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_GET_TASK_QUEUE(id),
    queryFn: () => getTaskQueue(id)
  })
